import LinkGroup from './LinkGroup';

export default {
  name: 'dn-link-groups',

  props: {
    category: {
      type: String,
      required: true,
    },
    ignore: {
      type: [String, Array],
    },
  },

  computed: {
    computedIgnore() {
      const { ignore } = this;
      if (!ignore) return [];
      return Array.isArray(ignore) ? ignore : [ignore];
    },

    computedCategory() {
      return this.$store.getters['navigation/category'](this.category);
    },
  },

  render(h) {
    const category = this.computedCategory;
    if (!category) return;

    const ignore = this.computedIgnore;
    const groups = category.groups.filter(group => {
      return group.links.length > 0 && !ignore.includes(group.id);
    });

    return h('div', {
      staticClass: 'dn-link-groups',
    }, groups.map(group => h(LinkGroup, {
      props: {
        category: this.category,
        group: group.id,
      },
      key: group.id,
    })))
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/LinkGroups.js